<template>
  <v-form
    ref="form"
    v-model="isFormValid"
  >
    <v-row class="mt-0 d-flex align-baseline">
      <v-col
        v-if="!compact"
        cols="12"
        md="4"
        class="text--primary text-h6"
      >
        Object
      </v-col>
      <v-col class="pb-0 mb-0">
        <v-textarea
          auto-grow
          rows="1"
          @input="handleInput"
          type="text"
          :label="compact ? 'Object' : null"
          placeholder="Enter object here"
          v-model="formValues['object']"
        />
      </v-col>
    </v-row>
    <template v-if="formValues['extra_fields']">
      <v-row
        class="mt-0 d-flex"
        v-for="(field, i) in formValues['extra_fields']"
        :key="i"
        ref="extraField"
      >
        <v-col :cols="$store.state.app.project.extra_fields_locked ? 12 : 10">
          <v-row>
            <v-col
              cols="12"
              md="6"
              class="text--primary text-h6"
            >
              <v-text-field
                rows="1"
                @input="handleInput"
                type="text"
                label="Custom field name"
                counter="60"
                placeholder="Enter field name here"
                v-model="formValues['extra_fields'][i]['name']"
                :rules="[rules.required, rules.max60, rules.uniqueName]"
                :readonly="$store.state.app.project.extra_fields_locked"
                :autofocus="!$store.state.app.project.extra_fields_locked"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="pb-0 mb-0"
            >
              <v-text-field
                rows="1"
                @input="handleInput"
                type="text"
                counter="255"
                label="Custom field value"
                placeholder="Enter information here"
                v-model="formValues['extra_fields'][i]['value']"
                :rules="[rules.max255]"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="2"
          v-if="!$store.state.app.project.extra_fields_locked"
        >
          <v-btn @click="deleteExtraField(i)">
            <v-icon color="primary">mdi-delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </template>
    <v-row
      justify="center"
      align="center"
      v-if="!$store.state.app.project.extra_fields_locked"
    >
      <v-btn
        text
        color="primary"
        @click="addExtraField()"
      >
        <v-icon class="mr-2">mdi-plus</v-icon>
        Add new field
      </v-btn>
    </v-row>
    <v-row class="mt-0 d-flex align-baseline">
      <v-col
        v-if="!compact"
        cols="12"
        md="4"
        class="text--primary text-h6"
      >
        Inspector signature date
      </v-col>
      <v-col class="pb-0 mb-0">
        <v-text-field
          rows="1"
          type="text"
          :label="
            compact
              ? formValues['inspector_signature_date']
                ? 'Inspector signature date'
                : 'Inspector signature date (not signed yet)'
              : null
          "
          placeholder="Not signed yet"
          v-model="formValues['inspector_signature_date']"
          readonly
          disabled
        />
      </v-col>
    </v-row>
    <v-row class="mt-0 d-flex align-baseline">
      <v-col
        v-if="!compact"
        cols="12"
        md="4"
        class="text--primary text-h6"
      >
        Operator signature date
      </v-col>
      <v-col class="pb-0 mb-0">
        <v-text-field
          rows="1"
          type="text"
          :label="
            compact
              ? formValues['operator_signature_date']
                ? 'Operator signature date'
                : 'Operator signature date (not signed yet)'
              : null
          "
          placeholder="Not signed yet"
          v-model="formValues['operator_signature_date']"
          readonly
          disabled
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { INSPECTION_FORM_MODEL } from "@/utils/consts"
import { cloneDeep, capitalize, lowerCase } from "lodash"

export default {
  name: "InspectionProcessForm",
  components: {},
  props: {
    value: {
      type: Object,
      required: true
    },
    compact: {
      type: Boolean,
      default: true
    },
    finalized: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFormValid: true,
      formValues: INSPECTION_FORM_MODEL,
      rules: {
        required: value => !!value || "Required",
        max60: value => !value || value.length <= 60 || "60 characters max",
        max255: value => !value || value.length <= 255 || "255 characters max",
        uniqueName: value => this.checkNameIsUnique(value) || "Field name already used"
      }
    }
  },
  methods: {
    capitalize,
    lowerCase,
    handleInput() {
      this.$emit("input", this.formValues)
      this.$refs.form.validate()
    },
    addExtraField() {
      this.$set(this.formValues.extra_fields, this.formValues.extra_fields.length, {
        name: "New field",
        value: null
      })
      this.handleInput()
      this.$nextTick(_ => {
        this.$refs.form.validate()
      })
    },
    deleteExtraField(i) {
      this.formValues.extra_fields.splice(i, 1)
      this.handleInput()
      this.$refs.form.validate()
    },
    checkNameIsUnique(name) {
      return (
        this.formValues.extra_fields.reduce((previousValue, currentElement) => {
          return previousValue + (currentElement.name == name)
        }, 0) <= 1
      )
    }
  },
  mounted() {
    if (this.value) {
      this.formValues = cloneDeep(this.value)
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue && newValue !== oldValue) this.formValues = cloneDeep(this.value)
    },
    isFormValid(val) {
      this.$emit("formValid", val)
    }
  }
}
</script>
